export const tilesAddress = {
  1: '0x64931F06d3266049Bf0195346973762E6996D764',
  4: '0x64931F06d3266049Bf0195346973762E6996D764',
}[process.env.REACT_APP_READONLY_CHAIN_ID as string] as string
